import React from "react";
import styles from "../Sections/Sections.module.css";

const Sections = () => {
  return (
    <div className={styles.containerBox}>
      <div className={styles.container}>
        <div className={styles.SectionDiv1}>
          <div className={styles.Sections1}>
            <div className={styles.Icondiv}>
              <img src="Images/icon-01.webp" alt="icon of Deseyne® high success rate vs multifocals" loading="lazy" decoding="async" />
            </div>
            <div className={styles.content}>
              <h3 className={styles.subheading}>High Success Rate</h3>
              <p className={styles.desc}>
                Vs. multifocal solutions, where between 60% and 70% of contact
                lens fittings fail compared to an +80% success rate for EDOF
                fittings.
              </p>
            </div>
          </div>
          <div className={styles.Sections1}>
            <div className={styles.Icondiv}>
              <img src="Images/icon-02.webp" alt="Brain icon representing no cognitive effort needed between near and far focus" loading="lazy" decoding="async" />
            </div>
            <div className={styles.content}>
              <h3 className={styles.subheading}>Easy Transition</h3>
              <p className={styles.desc}>
                Enables smooth near-to-far focus changes with no cognitive effort, while reducing prescription adjustments and fine-tuning for fitters.
              </p>
            </div>
          </div>
          <div className={styles.Sections1}>
            <div className={styles.Icondiv}>
              <img src="Images/icon-03.webp" alt="Stylized V icon representing versatility of Deseyne® lenses" loading="lazy" decoding="async" />
            </div>
            <div className={styles.content}>
              <h3 className={styles.subheading}>Versatility</h3>
              <p className={styles.desc}>
                No cognitive adaptation when switching focus between near and far. Contrast and clarity are preserved even in low-light conditions

              </p>
            </div>
          </div>
        </div>
        <div className={styles.SectionDiv1}>
          <div className={styles.Sections1}>
            <div className={styles.Icondiv}>
              <img src="Images/icon-04.webp" alt="icon of optometry chair illustrating practice benefit of reduced patient chair time with Deseyne® lenses" loading="lazy" decoding="async" />
            </div>
            <div className={styles.content}>
              <h3 className={styles.subheading}>Better for your practice</h3>
              <p className={styles.desc}>
                Reduced Patient Chair Time: from 95 minutes across three visits
                to just 20 minutes in one visit. Longer Patient Lifetime: average CL wearer around 13 years vs.
                EDOF +20 years.
              </p>
            </div>
          </div>
          <div className={styles.Sections1}>
            <div className={styles.Icondiv}>
              <img src="Images/icon-05.webp" alt="Dollar sign with downward arrow symbolizing reduced chair time, lower inventory needs, and higher fitting success" loading="lazy" decoding="async" />
            </div>
            <div className={styles.content}>
              <h3 className={styles.subheading}>Less Inventory, Lower Cost</h3>
              <p className={styles.desc}>
                Fewer SKUs required: 180+ SKUs for multifocal contact lenses vs. 61 SKUs for Deseyne® EDOF contact lenses.
              </p>
              
            </div>
          </div>
          <div className={styles.Sections1}> 
            <div className={styles.Icondiv}>
              <img src="Images/icon-06.webp" alt="icon with heart representing long term patient comfort and eye health with Lacrimass™ and FusionTechnology™" loading="lazy" decoding="async" />
            </div>
            <div className={styles.content}>
              <h3 className={styles.subheading}>True Comfort</h3>
              <p className={styles.desc}>
                Lacrimass™ and FusionTechnology™ incorporate hyaluronic acid (HA) and
                tamarind seed polysaccharide (TSP), promoting hydration and comfort during daily wear.
              </p>
            </div>
          </div>
        </div>
      </div>
       <p className={styles.linkDecription}>Pucker, A. D., & Tichenor, A. A. (2020). <span className={styles.italictext}>A review of contact lens dropout. </span> <span> Clinical Optometry, 12,
          85–94. Retrieved from </span> <a className={styles.linkcontaint} href='https://pmc.ncbi.nlm.nih.gov/articles/PMC7323801/' target='blank' rel="noopener noreferrer">https://pmc.ncbi.nlm.nih.gov/articles/PMC7323801/</a></p>
     
    </div>
  );
};

export default Sections;
